import {
  Box,
  Grid,
  IconButton,
  AppBar as MuiAppBar,
  Toolbar,
  Typography,
  styled,
  useTheme,
} from '@mui/material';

import Activities from 'components/SideMenuItems/Activities';
import ChangePassword from 'components/SideMenuItems/ChangePassword';
import ChangeThemeButton from 'components/ChangeThemeButton';
import { LANDING_PAGE_URL } from 'config/Configuration';
import LogoutModal from 'components/SideMenuItems/Logout';
import Navbar from 'components/layout/Desktop/Navbar';
import Notification from '../Notification';
import Profile from 'components/SideMenuItems/Profile';
import { SanaCashLogo } from 'assets/Icon';
import Security from 'components/SideMenuItems/Security';
import Support from 'components/SideMenuItems/Support';
import UserOptions from './Components/UserOptions';
import { useIsUserBlocked } from 'hooks/useIsUserBlocked';
import primaryLogo from "assets/logo/primaryTypographyLogo.png";
import secondaryLogo from "assets/logo/secondaryTypographyLogo.png";
import { useSelector } from 'react-redux';
import { useMemo, useState } from 'react';

function TopAppBar({ open, handleDrawerOpen, drawerWidth }) {
  const theme = useTheme();
  const isUserBlocked = useIsUserBlocked();

  const [openNotification, setOpenNotification] = useState(false);

  const [openSecurity, setOpenSecurity] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [openSupport, setOpenSupport] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [openActivities, setOpenActivities] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);

  const latestNotifications = useSelector(
    (state) => state.notification.latestNotifications?.data
  );

  const logoTheme = useMemo(() => {
    const logoObject = {
      primary: primaryLogo,
      secondary: secondaryLogo,
      info: primaryLogo,
    }
    
    return logoObject[theme.mode]
    
  },[theme])



  return (
    <>
      <AppBar position="fixed" open={open} drawerWidth={drawerWidth}>
        <Toolbar>
          <Grid container alignItems="center">
            <Grid item xs={3}>
              <Box display="flex" alignItems="center">
                {!isUserBlocked && (
                  <IconButton
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                    sx={{
                      color: theme.palette.modules.menuIconColor,
                      mr: 2,
                      ...(open && { display: 'none' }),
                    }}
                  >
                    <ion-icon name="menu-outline"></ion-icon>
                  </IconButton>
                )}

                <BoxLogo>
                  <a href={LANDING_PAGE_URL}>
                    <img src={logoTheme} alt="typography-logo" />
                  </a>
                </BoxLogo>
              </Box>
            </Grid>

            <Grid item xs={6} textAlign="center">
              {!isUserBlocked && <Navbar />}
            </Grid>

            <Grid
              item
              xs={3}
              textAlign="right"
              display={'flex'}
              alignItems={'center'}
              justifyContent={'end'}
            >
              <UserOptions
                openSecurity={openSecurity}
                openChangePassword={openChangePassword}
                openSupport={openSupport}
                openProfile={openProfile}
                openActivities={openActivities}
                setOpenSecurity={setOpenSecurity}
                setOpenChangePassword={setOpenChangePassword}
                setOpenSupport={setOpenSupport}
                setOpenProfile={setOpenProfile}
                setOpenActivities={setOpenActivities}
                setOpenLogout={setOpenLogout}
              />

              <IconButton
                color="text"
                onClick={() => setOpenNotification(true)}
              >
                <ion-icon name="notifications-outline"></ion-icon>
                <TypographyBadge component="span" variant="subtitle1">
                  {latestNotifications?.unreadCount || 0}
                </TypographyBadge>
              </IconButton>

              <ChangeThemeButton />
            </Grid>
          </Grid>
        </Toolbar>

        <Notification
          open={openNotification}
          onClose={() => setOpenNotification(false)}
        />
      </AppBar>

      {openProfile && (
        <Profile open={openProfile} onClose={() => setOpenProfile(false)} />
      )}

      {openSecurity && (
        <Security open={openSecurity} onClose={() => setOpenSecurity(false)} />
      )}

      {openChangePassword && (
        <ChangePassword
          open={openChangePassword}
          onClose={() => setOpenChangePassword(false)}
        />
      )}

      {openSupport && (
        <Support open={openSupport} onClose={() => setOpenSupport(false)} />
      )}

      {openActivities && (
        <Activities
          open={openActivities}
          onClose={() => setOpenActivities(false)}
        />
      )}

      {openLogout && (
        <LogoutModal open={openLogout} onClose={() => setOpenLogout(false)} />
      )}
    </>
  );
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open, drawerWidth }) => ({
  background: theme.palette.modules.appBar,
  boxShadow: 'none',
  filter: `drop-shadow(0 1px 10px ${theme.palette.modules.headerShadow})`,
  zIndex: '1100',

  transition: theme.transitions.create(['margin', 'width', 'zIndex'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    zIndex: '900',
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const BoxLogo = styled(Box)(({ theme }) => ({
  a: {
    maxWidth: '120px',
    display: 'flex',
    margin: 'auto',
    
    img: {
      maxWidth: '120px',
      height: "auto"
    }
  },
}));

const TypographyBadge = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.modules.backgroundBadge,
  position: 'absolute',
  borderRadius: '50%',
  right: '0px',
  minWidth: '20px',
  textAlign: 'center',
  top: 0,
}));
export default TopAppBar;
